import React, { useEffect, useRef } from "react";
import loadEcharts from "../functions/echartsLoader";

// Tenký obal nad ECharts (načítá se z CDN jako na stránce benchmarku).
export default function EChart({ option, height = 280, className }) {
  const ref = useRef(null);

  useEffect(() => {
    let chart;
    let disposed = false;
    const onResize = () => chart && chart.resize();
    loadEcharts()
      .then((echarts) => {
        if (disposed || !ref.current) return;
        chart = echarts.getInstanceByDom(ref.current) || echarts.init(ref.current, null, { renderer: "svg" });
        chart.setOption(option, true);
        window.addEventListener("resize", onResize);
      })
      .catch(() => {});
    return () => {
      disposed = true;
      window.removeEventListener("resize", onResize);
      if (chart) chart.dispose();
    };
  }, [option]);

  return <div ref={ref} className={className} style={{ width: "100%", height }} />;
}
